module.exports = __webpack_public_path__ + "img/pw.069ec370.svg";